/**
 * @flow
 * @relayHash f5053afebdbf8a44c2220797c00534ec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CannotBulkReviewReason = "HAS_DRAFT" | "INACTIVE_AUTHOR" | "SPECIFIC_EXPIRATION_DATE" | "%future added value";
export type DocumentsForReviewQueryVariables = {|
  after?: ?string,
  first?: ?number,
  sort?: ?string,
  justMine?: ?boolean,
|};
export type DocumentsForReviewQueryResponse = {|
  +documentsToReview: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: string,
          +category: {|
            +name: string
          |},
          +expirationDate: ?string,
          +restricted: boolean,
          +preview: ?string,
          +bloc: {|
            +name: string
          |},
          +isHomeBloc: ?boolean,
          +author: {|
            +firstName: string,
            +lastName: string,
            +title: ?string,
          |},
          +cannotBulkReviewReason: ?CannotBulkReviewReason,
        |}
      |}>,
    |},
    +buckets: ?any,
    +showBulkReview: ?boolean,
    +rssFeedUrl: ?string,
  |}
|};
export type DocumentsForReviewQuery = {|
  variables: DocumentsForReviewQueryVariables,
  response: DocumentsForReviewQueryResponse,
|};
*/


/*
query DocumentsForReviewQuery(
  $after: String
  $first: Int
  $sort: String
  $justMine: Boolean
) {
  documentsToReview(justMine: $justMine, sort: $sort) {
    documents(after: $after, first: $first) {
      totalCount
      edges {
        node {
          pk
          name
          category {
            name
            id
          }
          expirationDate
          restricted
          preview
          bloc {
            name
            id
          }
          isHomeBloc
          author {
            firstName
            lastName
            title
            id
          }
          cannotBulkReviewReason
          id
        }
      }
    }
    buckets
    showBulkReview
    rssFeedUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "justMine",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "justMine",
    "variableName": "justMine",
    "type": "Boolean"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  v5
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "preview",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isHomeBloc",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cannotBulkReviewReason",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showBulkReview",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rssFeedUrl",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v19 = [
  v5,
  v18
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DocumentsForReviewQuery",
  "id": "8fb1ebebba66262a0532a0800b74686a",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DocumentsForReviewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReview",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentsToReviewType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": v2,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryType",
                        "plural": false,
                        "selections": v6
                      },
                      v7,
                      v8,
                      v9,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v6
                      },
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "author",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ApprovalStepUserType",
                        "plural": false,
                        "selections": [
                          v11,
                          v12,
                          v13
                        ]
                      },
                      v14
                    ]
                  }
                ]
              }
            ]
          },
          v15,
          v16,
          v17
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DocumentsForReviewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReview",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentsToReviewType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": v2,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryType",
                        "plural": false,
                        "selections": v19
                      },
                      v7,
                      v8,
                      v9,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v19
                      },
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "author",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ApprovalStepUserType",
                        "plural": false,
                        "selections": [
                          v11,
                          v12,
                          v13,
                          v18
                        ]
                      },
                      v14,
                      v18
                    ]
                  }
                ]
              }
            ]
          },
          v15,
          v16,
          v17
        ]
      }
    ]
  }
};
})();
node.text = "query DocumentsForReviewQuery(\n  $after: String\n  $first: Int\n  $sort: String\n  $justMine: Boolean\n) {\n  documentsToReview(justMine: $justMine, sort: $sort) {\n    documents(after: $after, first: $first) {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          category {\n            name\n            id\n          }\n          expirationDate\n          restricted\n          preview\n          bloc {\n            name\n            id\n          }\n          isHomeBloc\n          author {\n            firstName\n            lastName\n            title\n            id\n          }\n          cannotBulkReviewReason\n          id\n        }\n      }\n    }\n    buckets\n    showBulkReview\n    rssFeedUrl\n  }\n}\n";
(node/*: any*/).hash = '91b2ecc7cf1cadd9b50c6f4b8b17a076';
module.exports = node;
